import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classes from './AddList.module.scss';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import Input from 'Flow2/components/UI/Input/Input';
import Button from 'Flow2/components/UI/Button/Button';
import * as hf from 'Flow2/util/helperFunctions.js';
import * as actions from 'store/actions/index';
import iconDelete from 'PMDB/assets/images/png_icons/cancel_icon_black.png';
import { FormattedMessage } from 'react-intl';

const SinglePassword = (props) => {
     return (<FlexRow  className={[classes.Row, classes.Pwd].join(' ')}>
                    <span className={classes.RowData}><FormattedMessage id="common.password" /></span>
					<span className={classes.RowData}>{props.pwd}</span>
                </FlexRow>);
}

const AddListRow = (props) => {
    let img = "";
    if(props.canRemove) {
        img = (<span><img alt="" className="pointer" onClick={props.remove} src={iconDelete} /></span>);
    }
    
     return (<FlexRow  className={[classes.Row, classes[props.canRemove]].join(' ')}>
                    <span onClick={props.click} className={classes.RowData}>{props.element.name}</span>
					<span onClick={props.click} className={classes.RowData}>{props.element.email}</span>
					{/*<span onClick={props.click} className={classes.RowData}>{props.element.pwd}</span>*/}
                    {img}
                </FlexRow>);
}

const AddListHeader = (props) => {
	let img = "";
    if(props.canRemove) {
        img = (<span><img alt="" className={classes.RowDataHide} src={iconDelete} /></span>);
    }
	
     return (<FlexRow  className={[classes.Row, classes[props.canRemove]].join(' ')}>
                    <span onClick={props.click} className={classes.RowData}><FormattedMessage id="common.name" /></span>
					<span onClick={props.click} className={classes.RowData}><FormattedMessage id="common.email" /></span>
					{/*<span onClick={props.click} className={classes.RowData}><FormattedMessage id="common.password" /></span>*/}
					{img}
                </FlexRow>);
}

const AddListInput = (props) => {
    if(!props.showInput) {
        return "";
    }
    
    let addContact = "";
    if (props.config.ftvContacts) {
        
        return(
            <FlexRow className={[classes.Control, classes.Seperator, 'relative'].join(' ')}>
                <Button
                    key="ContactsToRoom"
                    btnType="Dark"
                    clicked={() => {
                        props.ftvContactsSetRoom(props.id);
                        props.history.push({
                            pathname: "/contacts"
                        });
                    }}>
                    <FormattedMessage id="page.rooms.addContacts" defaultMessage="Add Contacts" />
                </Button>
            </FlexRow>
        );
    }
    
    return (
        <FlexColumn>
            <FlexRow className={[classes.Input, 'relative'].join(' ')}>
                <Input
                    value={props.element.name}
                    elementConfig={{type: 'text', placeholder:"name"}}
                    changed={(event) => { props.changed({ ...props.element, name: event.target.value }) }}/>
            </FlexRow>
            <FlexRow className={[classes.Input, 'relative'].join(' ')}>
                <Input
                    value={props.element.email}
                    elementConfig={{type: 'text', placeholder:"email"}}
                    changed={(event) => { props.changed({ ...props.element, email: event.target.value }) }}/>
            </FlexRow>
            <FlexRow className={[classes.Control, 'relative'].join(' ')}>
                {addContact}
            
                <Button btnType="Red" clicked={props.add}><FormattedMessage id="common.add" /></Button>
					{/*<Button btnType="White" clicked={props.clear}><FormattedMessage id="common.cancel" /></Button>*/}
            </FlexRow>
        </FlexColumn>
           );
}

class RoomUserList extends React.Component {
    
    constructor(props){
		super(props);
		this.state = {
           // element: this.createNewElement(),
            index: -1,
            data: props.data || [],
            showList: props.showList || true,
            showInput: props.add ? true : false,
            canRemove: props.remove ? true : false,
			password: props.pwd || RoomUserList.getPassword(props)//props.singlePassword || hf.getRandomString(8, "-.,_:;!§$%&/")
		};
        
		this.state.element = this.createNewElement();
    }
	
	static getPassword(props) {
		if(!props.singlePassword) {
			return "";
		}
		
		const pwd = hf.getRandomString(12);
        
        const obj = {
            pwd: pwd,
            members: []
        }
        
		if(props.add) {
			props.add(JSON.stringify(obj));			
		}
		
		return pwd;
	}
    
    createNewElement = () => {
        return {
                name: "",
                email: "",
                id: "P" + hf.getRandomString(7),
                pwd: hf.getRandomString(12)
            };
    }
    
    onChangedHandler = (element) => {
        this.setState({ element: element });
    }
    
    onSelect = (element, index) => {
        if(!element.name || !element.email) {
            return;
        }
        
        const data = this.state.data;
        if(index > -1) {
            data[index] = element;
        } else {
            data.push(element);
        }
        
        const obj = {
            pwd: this.state.password,
            members: data
        }
        
        this.setState({ element: this.createNewElement(), data: data, index: -1 });
		this.props.add(JSON.stringify(obj));
    }
    
    onRemoveClick = (index) => {
        const data = this.state.data;
        data.splice(index, 1);
        this.setState({ element: this.createNewElement(), data: data, index: -1 });
        
        const obj = {
            pwd: this.state.password,
            members: data
        }
        
        this.props.add(JSON.stringify(obj));
        //this.props.add(JSON.stringify(data));
    }
    
    onRowClick = (element, index) => {
        this.setState({element: element, index: index});
    }
    
    onClearInput = () => {
        this.setState({ element: this.createNewElement(), index: -1 });
    }
    
    createList = () => {
        if(!this.state.showList) {
            return "";
        }
        
        return this.createRowList();
    }
    
    createRowList = () => {
        const rows = this.state.data.map((element, index) => {
            return (
                <AddListRow
                    key={element.id}
                    element={element}
                    click={() => {this.onRowClick(element, index)}}
                    remove={() => this.onRemoveClick(index)}
                    canRemove={this.state.canRemove} />
            );
        });
        
        return (
            <FlexColumn className={classes.List}>
				{ rows.length ? <AddListHeader canRemove={this.state.canRemove} /> : "" }
                {rows}
            </FlexColumn>
        );
    }
    
    render = () => {
        const input = (<AddListInput
                            id={this.props.id}
                            config={this.props.config}
                            ftvContactsSetRoom={this.props.ftvContactsSetRoom}
                            history={this.props.history}
                            showInput={this.state.showInput}
                            element={this.state.element}
                            changed={( element ) => this.onChangedHandler( element )}
                            clear={this.onClearInput}
                            add={() => {this.onSelect(this.state.element, this.state.index)}} />);
        
        return (
            <FlexColumn className={classes.AddList}>
				{ this.state.password && this.props.singlePassword ? <SinglePassword pwd={ this.state.password } /> : "" }
                { this.createList() }
                {input}
            </FlexColumn>
        );
    }
    
    static getDerivedStateFromProps(nextProps, prevState) {
        if(prevState) {
            return {
                input: nextProps.add ? prevState.input : "",
                data: nextProps.data || [],
                showList: nextProps.showList || true,
                showInput: (nextProps.add && true) || false,
                canRemove: (nextProps.remove && true) || false,
                password: prevState.password || RoomUserList.getPassword(nextProps) //nextProps.singlePassword || hf.getRandomString(8, "-.,_:;!§$%&/")
            }; 
        }
        
        return null;
    }
    /*
    componentWillReceiveProps(nextProps) {
        this.setState({
            input: nextProps.add ? this.state.input : "",
            data: nextProps.data || [],
            showList: nextProps.showList || true,
            showInput: (nextProps.add && true) || false,
            canRemove: (nextProps.remove && true) || false,
			password: this.getPassword(nextProps) //nextProps.singlePassword || hf.getRandomString(8, "-.,_:;!§$%&/")
        });
    }
*/
};

const mapStateToProps = (state, ownProps) => {
    return {
        users: state.user.users,
        config: state.ui.config
    }
} 

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        ftvContactsSetRoom: (id) => dispatch(actions.ftvContactsSetRoom(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RoomUserList));
